import { useEffect, useState } from "react";
import EmissionService from "../Services/EmissionService";
import useQueryParams from "#routers/useQueryParams";

export function useEmissionsReportDetail(
  id: string
): [any, string, () => void] {
  const [emissionReportDetail, setEmissionReportDetail] = useState({});
  const [fetchState, setFetchState] = useState("loading");
  const [lastFetchTime, setLastFetchTime] = useState(new Date());

  const updateEmissionReportDetail = () => {
    setLastFetchTime(new Date());
  };

  useEffect(() => {
    if (id) {
      EmissionService.getEmissionReportDetail()
        .then(({ data }: any) => {
          setEmissionReportDetail(data);
          setFetchState("loaded");
        })
        .catch(() => {
          setFetchState("error");
        });
    }
  }, [lastFetchTime]);

  return [emissionReportDetail, fetchState, updateEmissionReportDetail];
}

export function useEmissionsReportSummary(id, defaultDateRange) {
  const [emissionReportSummary, setEmissionReportSummary] = useState([]);
  const [fetchState, setFetchState] = useState("loading");
  const [lastFetchTime, setLastFetchTime] = useState(new Date());
  const [queryParams] = useQueryParams(defaultDateRange) as any;

  const updateEmissionReportSummary = () => {
    setLastFetchTime(new Date());
  };

  useEffect(() => {
    if (id) {
      EmissionService.getEmissionReportSummary()
        .then(({ data }: any) => {
          setEmissionReportSummary(data);
          setFetchState("loaded");
        })
        .catch(() => {
          setFetchState("error");
        });
    }
  }, [lastFetchTime, queryParams]);

  return [emissionReportSummary, fetchState, updateEmissionReportSummary];
}

export function useEmissionDetail(
  id,
  defaultDateRange
): [any, string, () => void] {
  const [facilitySummary, setFacilitySummary] = useState([]);
  const [fetchState, setFetchState] = useState("loading");
  const [lastFetchTime, setLastFetchTime] = useState(new Date());
  const [queryParams] = useQueryParams(defaultDateRange) as any;

  const updateFacilitySummary = () => {
    setLastFetchTime(new Date());
  };

  useEffect(() => {
    if (id) {
      EmissionService.getEmissionFacilityDetail()
        .then(({ data }: any) => {
          setFacilitySummary(data.data);
          setFetchState("loaded");
        })
        .catch(() => {
          setFetchState("error");
        });
    }
  }, [lastFetchTime, queryParams]);

  return [facilitySummary, fetchState, updateFacilitySummary];
}
